import { Link } from 'react-router-dom';
import { Button } from '@/shared/components/ui/Button';
import { ROUTES } from '@/routes/paths';

export function NotFoundPage() {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 bg-surface-container-low text-center">
      <p className="text-headline-lg font-bold text-primary">404</p>
      <div>
        <h1 className="text-headline-md text-on-surface">Page not found</h1>
        <p className="mt-1 text-data-md text-on-surface-variant">
          The page you’re looking for doesn’t exist.
        </p>
      </div>
      <Link to={ROUTES.dashboard}>
        <Button>Back to dashboard</Button>
      </Link>
    </div>
  );
}
